const uRLs = {
  AUTH_URL: process.env.REACT_APP_AUTH_URL,
  API_URL: process.env.REACT_APP_API_URL,
  APII_URL: process.env.REACT_APP_APII_URL,
  COOKIE_NAME: process.env.REACT_APP_COOKIE_NAME,
  COOKIE_NAME_ONE: process.env.REACT_APP_ACCESS_COOKIE_NAME,
  DOMAIN_ONE: process.env.REACT_APP_DOMAIN_ONE,
  DOMAIN_TWO: process.env.REACT_APP_DOMAIN_TWO,
  LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
  IMAGE_URL: process.env.REACT_APP_IMAGE_PREFIX,
  EXPENSE_MODULE: process.env.REACT_APP_EXPENSE_MODULE,
  ESTIMATE_MODULE: process.env.REACT_APP_ESTIMATE_MODULE,
  RECHARGE_MODULE: process.env.REACT_APP_RECHARGE_MODULE,
  MANAGEOUTLET_MODULE: process.env.REACT_APP_MANAGEOUTLET_MODULE,
  BARCODE_PRINT: process.env.REACT_APP_BARCODE_PRINT,
  REPORTS_MODULE: process.env.REACT_APP_REPORTS,
  STOCK_TRANSFER: process.env.REACT_APP_STOCK_TRANSFER,
  STOCK_ARRIVAL: process.env.REACT_APP_STOCK_ARRIVAL,
  STOCK_TRASH: process.env.REACT_APP_STOCK_TRASH,
  STAFF_ACCESS: process.env.REACT_APP_STAFF_ACCESS,
  SUB_STOCK: process.env.REACT_APP_SUBSTOCK,
  DASHBOARD_REFRESH_INTERVAL:
    process.env.REACT_APP_DASHBOARD_REFRESH_INTERVAL_MIN,
  PUBLIC_PORTAL_URL: process.env.REACT_APP_PUBLIC_PORTAL_URL,
  ADD_PRODUCT_IMAGE: process.env.REACT_APP_ADD_PRODUCT_IMAGE,
  ANALYTICS: process.env.REACT_APP_ANALYTICS,
  SERVICE: process.env.REACT_APP_SERVICE,
  JOBCARD: process.env.REACT_APP_JOBCARD,
  PROJECT: process.env.REACT_APP_PROJECT,
  DASHBOARD_PASSWORD: process.env.REACT_APP_DASHBOARD_PASSWORD,
  ALL_CUSTOMER: process.env.REACT_APP_ALL_CUSTOMER,
  ALL_PRODUCT: process.env.REACT_APP_ALL_PRODUCT,
  VOUCHER: process.env.REACT_APP_VOUCHER,
  FAVOURITE_SALE: process.env.REACT_APP_FAVOURITE_SALE,
  SUPPLIER: process.env.REACT_APP_SUPPLIER,
  PURCHASE: process.env.REACT_APP_PURCHASE,
  INVOICE_SETTINGS: process.env.REACT_APP_INVOICE_SETTINGS,
  CUSTOMER_BULK_UPLOAD: process.env.REACT_APP_CUSTOMER_BULK_UPLOAD,
  PRODUCT_BULK_UPLOAD: process.env.REACT_APP_PRODUCT_BULK_UPLOAD,
  UNIT: process.env.REACT_APP_UNIT,
  SUPPLIER_BULK_UPLOAD: process.env.REACT_APP_SUPPLIER_BULK_UPLOAD,
  RETURN_SALE: process.env.REACT_APP_RETURN_SALE,
  UPDATE_CHECK_INTERVAL: process.env.REACT_APP_UPDATE_CHECK_INTERVAL,
  PLAY_STORE_LINK: process.env.REACT_APP_PLAY_STORE_LINK,
  APP_STORE_LINK: process.env.REACT_APP_STORE_LINK,
  PRE_SALE: process.env.REACT_APP_PRESALE,
  CONTACT_PHONE: process.env.REACT_APP_CONTACT_PHONE,
};

export default uRLs;
